import { stocksStories } from './stocksStories.js';

function init() {
    stocksStories();
}

export {
    init   
}